import React from 'react';
import { connect } from 'react-redux';
import { statusUser } from './redux/reduxApi';
import { closeModal } from '../../app/modals/redux/modalActions';

const actions = {
  closeModal,
  statusUser,
};

function ModalStatus({ data, closeModal, statusUser }) {
  const item = data.item;
  const handleStatus = () => {
    const newValues = { ...data.item };
    newValues.status = data.item.status ? false : true;
    statusUser(data.auth, data.history, newValues);
    closeModal();
  };

  return (
    <div className='modal is-active'>
      <div className='modal-background' onClick={closeModal}></div>
      <div className='modal-card'>
        <header className='modal-card-head'>
          <div
            className={`modal-card-title has-text-${
              item.status ? 'danger' : 'info'
            } has-text-weight-normal`}
          >
            <i
              className={`is-size-4 mdi mdi-${
                item.status ? 'account-remove' : 'account-check'
              } mr-2`}
            />
            Set {item.status ? 'Non Aktif' : 'Aktif'}
          </div>
          <button
            onClick={closeModal}
            className='delete'
            aria-label='close'
          ></button>
        </header>
        <section className='modal-card-body is-size-6'>
          <p className='my-3 mx-1'>
            Apakah Anda ingin set user{' '}
            <span className='has-text-danger has-text-weight-semibold is-capitalized'>
              {item?.username}
            </span>{' '}
            menjadi {item?.status ? 'non aktif' : 'aktif'} ?
          </p>
        </section>
        <footer className='modal-card-foot'>
          <button
            onClick={() => handleStatus()}
            className='button is-info is-small is-rounded is-outlined'
          >
            <i className='is-size-6 mdi mdi-content-save icon' />
          </button>
          <button
            className='button custom-grey is-small is-rounded is-outlined'
            onClick={closeModal}
          >
            <i className='is-size-6 mdi mdi-arrow-left icon' />
          </button>
        </footer>
      </div>
    </div>
  );
}

export default connect(null, actions)(ModalStatus);
